module.exports = __webpack_public_path__ + "img/map-menu-1@2x.f3d11009.png";